import type { PropertyIn, PropertyPath } from '@/scopes/common/domain/types'
import type { StoreApi } from 'zustand'
import { setIn } from '@/scopes/common/domain/functions/objectDeepOperations'
import { AnchorHref } from '@/scopes/products/pages/components/Legacy/AnchorMenu/types'
import { create, createStore } from 'zustand'

interface PDPState {
  activeAnchorHref: AnchorHref
  anchorsTargetIntersecting: AnchorHref[]
}

type PriceStatePath = PropertyPath<PDPState>
interface PDPStateActions {
  setIn: (path: PriceStatePath, value: PropertyIn<PDPState, typeof path>) => void
  setActiveAnchorHref: (activeAnchorHref: AnchorHref) => void
}

export type PDPStore = PDPState & PDPStateActions

const defaultInitialState: PDPState = {
  activeAnchorHref: AnchorHref.General,
  anchorsTargetIntersecting: [],
}

create<PDPState>(set => ({
  ...defaultInitialState,
  setActiveAnchorHref: (activeAnchorHref: AnchorHref) => {
    set({ activeAnchorHref })
  },
}))

export type PDPStoreApi = Pick<StoreApi<PDPStore>, 'getState'>

export function createPDPStore(initialState: PDPState = defaultInitialState) {
  return createStore<PDPStore>(set => ({
    ...initialState,
    setIn: (path, value) => {
      set(state => setIn(state, path, value) as PDPState)
    },
    setActiveAnchorHref: (activeAnchorHref) => {
      set({ activeAnchorHref })
    },
  }))
}

export const pdpStore = createPDPStore()
